import { AiHubBreadcrumbModule } from "@aihub/ui/breadcrumb";
import { AiHubFlexListModule } from "@aihub/ui/flexlist";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrainCardListModule } from "@brain/modules/card-list/card-list.module";
import { TranslateModule } from "@ngx-translate/core";
import { DeloitteAiCardsModule } from "@shared/cards/cards.module";
import { DeloitteAiCommonModule } from "@shared/common";
import { DeloitteAiEmailModule } from "@shared/mail";
import { AssetDetailComponent } from "./ui/asset-detail";
import { AssetDetailSectionMenuItemDirective } from "./ui/asset-section";
import { AssetDetailFeaturesComponent } from "./ui/features/features.component";
import { AssetDetailMailComponent } from "./ui/mail/mail";
import { AssetDetailMarkdownComponent } from "./ui/markdown/markdown";
import { AssetDetailOverviewComponent } from "./ui/overview/overview";
import { AssetDetailPurchaseComponent } from "./ui/purchase/purchase";
import { AssetDetailFormatHeaderPipe } from "./utils/format-header.pipe";
import { AihubStickyDirective } from "./utils/sticky.directive";


@NgModule({
    declarations: [
        AssetDetailComponent,
        AssetDetailMailComponent,
        AssetDetailMarkdownComponent,
        AssetDetailFeaturesComponent,
        AssetDetailFormatHeaderPipe,
        AssetDetailOverviewComponent,
        AssetDetailPurchaseComponent,
        AssetDetailSectionMenuItemDirective,
        AihubStickyDirective
    ],
    imports: [
        CommonModule,
        BrainCardListModule,
        DeloitteAiCommonModule,
        DeloitteAiEmailModule,
        AiHubBreadcrumbModule,
        AiHubFlexListModule,
        DeloitteAiCardsModule,
        TranslateModule,
    ],
    exports: [
        AssetDetailComponent,
        AssetDetailMarkdownComponent,
        AssetDetailMailComponent,
        AssetDetailPurchaseComponent
    ]
})
export class BrainAssetDetailModule {
}
